<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6" :class="$vuetify.display.smAndUp ? 'pt-4' : 'pt-2'">
        <v-icon color="#063562" :icon="mdiFileDocument" class="mr-1" />
        <span id="policy-number"> {{ $t('L_policy_number') }}: </span>
        <span class="font-weight-bold">
          {{ contractId }}
        </span>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        class="text-right pr-4"
        :class="$vuetify.display.smAndUp ? 'pt-4' : 'pt-1 pb-2'"
      >
        <span class="text-right">
          <span>{{ $t('L_status') }}</span>
          <span class="ml-2">
            <v-icon class="mr-1" :color="policyStatusIconColor" :icon="mdiAlertCircle" />
            <span> {{ $t('L_terminated_application') }}</span>
          </span>
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { mdiAlertCircle, mdiFileDocument } from '@mdi/js';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TerminatedPolicyCardTopBar',
  data() {
    return { mdiAlertCircle, mdiFileDocument };
  },
  props: {
    contractId: {
      type: String,
      required: true,
    },
  },
  computed: {
    policyStatusIconColor() {
      return 'error';
    },
  },
});
</script>
